import { render, staticRenderFns } from "./PriceTrackingCompare.vue?vue&type=template&id=bdf21ae2&scoped=true"
import script from "./PriceTrackingCompare.vue?vue&type=script&lang=js"
export * from "./PriceTrackingCompare.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./PriceTrackingCompare.vue?vue&type=style&index=1&id=bdf21ae2&prod&scoped=true&lang=css"
import style2 from "./PriceTrackingCompare.vue?vue&type=style&index=2&id=bdf21ae2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf21ae2",
  null
  
)

export default component.exports